<template>
  <img
    src="/tgl-logo-app.png"
    width="40"
    height="40"
    alt="TGL Secure Documents"
    style="width: 40px; height: 40px; object-fit: contain; display: block;"
  >
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
